import React from "react";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";

export function TabelaAproveitamentoHorario(props) {
    return (
        <Row>
            <Grid cols="12 12 12 8">
                <ContentCard
                    style={{
                        backgroundColor: "#30303d",
                        color: "#fff",
                        padding: 15,
                    }}
                >
                    <ContentCardBody
                        padding="0"
                        style={{
                            backgroundColor: "#30303d",
                            height: window.innerWidth < 962 ? "fit-content" : 550,
                        }}
                    >
                        <p className="text-center" style={{ fontSize: 16, margin: 0 }}>
                            Aproveitamento Horário do {props.filtro.mes_base == 1 ? "Último Mês" : "Mês Anterior"}
                        </p>
                        <Row style={{ marginBottom: 20 }}>
                            <Grid
                                cols="12 12 12 12"
                                style={{
                                    maxHeight: 520,
                                    padding: 10,
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                }}
                            >
                                <Table responsive maxHeight={500} minWidth={window.innerWidth < 962 ? 1200 : "100%"}>
                                    <THead>
                                        <Tr>
                                            <Th minHeight={67} sticky backgroundColor="#30303d"></Th>
                                            <Th minHeight={67} sticky colSpan={11} alignCenter backgroundColor="#44444f" style={{ textWrap: "nowrap" }}>
                                                Perfil de Consumo <p style={{ margin: 0 }}>(Aproveitamento Horário % de kWh)</p>
                                            </Th>
                                            <Th minHeight={67} sticky colSpan={5} alignCenter backgroundColor="#30303d" verticalAlign="middle">
                                                Custos de Tarifas
                                            </Th>
                                        </Tr>
                                        <Tr>
                                            <Th rowSpan={2} top={65} sticky backgroundColor="#30303d" style={{ verticalAlign: "middle" }}>
                                                Unidade Consumidora
                                            </Th>
                                            <Th colSpan={2} alignCenter top={65} sticky backgroundColor="#44444f">
                                                Total
                                            </Th>
                                            <Th colSpan={3} top={65} minWidth={150} sticky alignCenter color="#ff6e81" backgroundColor="#44444f">
                                                Horário Ponta
                                            </Th>
                                            <Th colSpan={3} top={65} minWidth={150} sticky alignCenter color="#a3b0f0" backgroundColor="#44444f">
                                                Horário F. Ponta
                                            </Th>
                                            <Th colSpan={3} top={65} minWidth={150} sticky alignCenter color="#67f087" backgroundColor="#44444f">
                                                Horário Reservado
                                            </Th>
                                            <Th rowSpan={2} top={65} sticky alignCenter color="#ff6e81" backgroundColor="#30303d">
                                                Horário Ponta
                                            </Th>
                                            <Th rowSpan={2} top={65} sticky alignCenter color="#a3b0f0" backgroundColor="#30303d">
                                                Horário F. Ponta
                                            </Th>
                                            <Th rowSpan={2} top={65} sticky alignCenter color="#67f087" backgroundColor="#30303d">
                                                Horário Reservado
                                            </Th>
                                            <Th rowSpan={2} top={65} sticky alignCenter color="#ff6e81" backgroundColor="#30303d" title="Tarifa Média Bruta">
                                                TMB
                                            </Th>
                                            <Th
                                                rowSpan={2}
                                                top={65}
                                                sticky
                                                alignCenter
                                                color="#a3b0f0"
                                                backgroundColor="#30303d"
                                                title="Tarifa Média Líquida (sem demanda e sem reativos"
                                            >
                                                TML
                                            </Th>
                                        </Tr>
                                        <Tr>
                                            <Th top={110} sticky alignCenter backgroundColor="#44444f">
                                                Qtd.
                                            </Th>
                                            <Th top={110} sticky alignCenter backgroundColor="#44444f">
                                                %
                                            </Th>
                                            <Th top={110} sticky alignCenter color="#daa710" backgroundColor="#44444f">
                                                Alerta
                                            </Th>
                                            <Th top={110} sticky alignCenter color="#ff6e81" backgroundColor="#44444f">
                                                Qtd.
                                            </Th>
                                            <Th top={110} sticky alignCenter color="#ff6e81" backgroundColor="#44444f">
                                                %
                                            </Th>
                                            <Th top={110} sticky alignCenter color="#daa710" backgroundColor="#44444f">
                                                Alerta
                                            </Th>
                                            <Th top={110} sticky alignCenter color="#a3b0f0" backgroundColor="#44444f">
                                                Qtd.
                                            </Th>
                                            <Th top={110} sticky alignCenter color="#a3b0f0" backgroundColor="#44444f">
                                                %
                                            </Th>
                                            <Th top={110} sticky alignCenter color="#daa710" backgroundColor="#44444f">
                                                Alerta
                                            </Th>
                                            <Th top={110} sticky alignCenter color="#67f087" backgroundColor="#44444f">
                                                Qtd.
                                            </Th>
                                            <Th top={110} sticky alignCenter color="#67f087" backgroundColor="#44444f">
                                                %
                                            </Th>
                                        </Tr>
                                    </THead>
                                    <TBody>
                                        {props.listaConsumoPercentualPorHorarioUltimoMes.map((item, i) => {
                                            const grupoA = [1, 4].includes(parseInt(item.id_grupo_faturamento));
                                            const grupoB = [2, 3].includes(item.id_grupo_faturamento);
                                            const irrigante = !!item.irrigante;
                                            const temSubsidioIrrigante = !!item.subsidio_irrigante;

                                            let percentual_horario_ponta = parseFloat(item.percentual_horario_ponta || 0);
                                            let percentual_horario_fora_ponta = parseFloat(item.percentual_horario_fora_ponta || 0);
                                            let percentual_horario_reservado = parseFloat(item.percentual_horario_reservado || 0);
                                            let percentual_total = percentual_horario_ponta + percentual_horario_fora_ponta + percentual_horario_reservado;

                                            let consumo_horario_ponta = parseFloat(item.consumo_horario_ponta || 0);
                                            let consumo_horario_fora_ponta = parseFloat(item.consumo_horario_fora_ponta || 0);
                                            let consumo_horario_reservado = parseFloat(item.consumo_horario_reservado || 0);
                                            let consumo_total = consumo_horario_ponta + consumo_horario_fora_ponta + consumo_horario_reservado;

                                            const atintiuConsumoMinimo = consumo_total > 2000;

                                            let tooltipAlertaPonta = "";
                                            let tooltipAlertaForaPonta = "";
                                            let tooltipAlertaReservado = "";

                                            //VALIDAÇÃO ALERTA PONTA VERDE -----------------------------------------------------------------------------------------------------------------------------
                                            const alertaPontaVerde =
                                                atintiuConsumoMinimo &&
                                                ((!irrigante && grupoA && percentual_horario_ponta <= 15) || (irrigante && grupoA && percentual_horario_ponta <= 2));

                                            if (alertaPontaVerde && percentual_horario_ponta <= 15) {
                                                tooltipAlertaPonta = "Consumo Ponta não passou de 15%";
                                            } else if (alertaPontaVerde && percentual_horario_ponta <= 2) {
                                                tooltipAlertaPonta = "Consumo Ponta não passou de 2%";
                                            }

                                            //VALIDAÇÃO ALERTA PONTA VERMELHO --------------------------------------------------------------------------------------------------------------------------
                                            const alertaPontaVermelho =
                                                atintiuConsumoMinimo &&
                                                ((!irrigante && grupoA && percentual_horario_ponta > 15) || (irrigante && grupoA && percentual_horario_ponta > 2));

                                            if (alertaPontaVermelho && percentual_horario_ponta > 15) {
                                                tooltipAlertaPonta = "Consumo Ponta passou de 15%";
                                            } else if (alertaPontaVermelho && percentual_horario_ponta > 2) {
                                                tooltipAlertaPonta = "Consumo Ponta passou de 2%";
                                            }

                                            //VALIDAÇÃO ALERTA FORA PONTA VERDE -------------------------------------------------------------------------------------------------------------------------
                                            const alertaForaPontaVerde =
                                                atintiuConsumoMinimo &&
                                                ((!irrigante && grupoA && percentual_horario_fora_ponta >= 85) ||
                                                    (irrigante && grupoB && temSubsidioIrrigante && percentual_horario_fora_ponta <= 60));

                                            if (alertaForaPontaVerde && percentual_horario_fora_ponta == 85) {
                                                tooltipAlertaForaPonta = "Consumo Fora Ponta atingiu 85%";
                                            } else if (alertaForaPontaVerde && percentual_horario_fora_ponta > 85) {
                                                tooltipAlertaForaPonta = "Consumo Fora Ponta passou de 85%";
                                            } else if (alertaForaPontaVerde && percentual_horario_fora_ponta <= 60) {
                                                tooltipAlertaForaPonta = "Consumo Fora Ponta não passou de 60%";
                                            }

                                            //VALIDAÇÃO ALERTA FORA PONTA VERMELHO ---------------------------------------------------------------------------------------------------------------------
                                            const alertaForaPontaVermelho =
                                                atintiuConsumoMinimo &&
                                                ((!irrigante && grupoA && percentual_horario_fora_ponta < 85) ||
                                                    (irrigante && grupoB && temSubsidioIrrigante && percentual_horario_fora_ponta > 60));

                                            if (alertaForaPontaVermelho && percentual_horario_fora_ponta < 85) {
                                                tooltipAlertaForaPonta = "Consumo Fora Ponta ficou abaixo de 85%";
                                            } else if (alertaForaPontaVermelho && percentual_horario_fora_ponta > 60) {
                                                tooltipAlertaForaPonta = "Consumo Fora Ponta passou de 60%";
                                            }

                                            //VALIDAÇÃO ALERTA RESERVADO VERDE -------------------------------------------------------------------------------------------------------------------------
                                            const alertaReservadoVerde =
                                                atintiuConsumoMinimo &&
                                                ((irrigante && grupoA && temSubsidioIrrigante && percentual_horario_reservado >= 40) ||
                                                    (irrigante && grupoB && temSubsidioIrrigante && percentual_horario_reservado >= 35));

                                            if (irrigante && grupoA && temSubsidioIrrigante && percentual_horario_reservado == 40) {
                                                tooltipAlertaReservado = "Consumo Reservado atingiu 40%";
                                            } else if (irrigante && grupoA && temSubsidioIrrigante && percentual_horario_reservado > 40) {
                                                tooltipAlertaReservado = "Consumo Reservado passou de 40%";
                                            } else if (irrigante && grupoB && temSubsidioIrrigante && percentual_horario_reservado == 35) {
                                                tooltipAlertaReservado = "Consumo Reservado atingiu 35%";
                                            } else if (irrigante && grupoB && temSubsidioIrrigante && percentual_horario_reservado > 35) {
                                                tooltipAlertaReservado = "Consumo Reservado passou de 35%";
                                            }

                                            //VALIDAÇÃO ALERTA RESERVADO VERMELHO ----------------------------------------------------------------------------------------------------------------------
                                            const alertaReservadoVermelho =
                                                atintiuConsumoMinimo &&
                                                ((irrigante && grupoA && temSubsidioIrrigante && percentual_horario_reservado < 40) ||
                                                    (irrigante && grupoB && temSubsidioIrrigante && percentual_horario_reservado < 35));

                                            if (irrigante && grupoA && temSubsidioIrrigante && percentual_horario_reservado < 40) {
                                                tooltipAlertaReservado = "Consumo Reservado ficou abaixo de 40%";
                                            } else if (irrigante && grupoB && temSubsidioIrrigante && percentual_horario_reservado < 35) {
                                                tooltipAlertaReservado = "Consumo Reservado ficou abaixo de 35%";
                                            }

                                            return (
                                                <Tr key={i}>
                                                    <Td color="#fff">
                                                        {item.agrupador.substring(0, 80)}
                                                        {item.agrupador.length > 80 ? "..." : ""}
                                                    </Td>
                                                    <Td backgroundColor="#44444f" color="#fff" alignCenter>
                                                        {adicionarPontosMilhar(consumo_total, 0)}
                                                    </Td>
                                                    <Td backgroundColor="#44444f" color="#fff" alignCenter>
                                                        {adicionarPontosMilhar(percentual_total)}
                                                    </Td>
                                                    <Td backgroundColor="#44444f" alignCenter>
                                                        {alertaPontaVerde ? (
                                                            <>
                                                                <i
                                                                    style={{
                                                                        color: "#26bc58",
                                                                        marginRight: 5,
                                                                    }}
                                                                    className="fas fa-thumbs-up"
                                                                ></i>
                                                                <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {alertaPontaVermelho ? (
                                                            <>
                                                                <i
                                                                    style={{
                                                                        color: "#c73b55",
                                                                        marginRight: 5,
                                                                    }}
                                                                    className="fas fa-exclamation-circle"
                                                                ></i>
                                                                <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {!alertaPontaVerde && !alertaPontaVermelho ? <b style={{ color: "#daa710" }}> - </b> : ""}
                                                    </Td>
                                                    <Td alignCenter color="#ff6e81" backgroundColor="#44444f">
                                                        {adicionarPontosMilhar(consumo_horario_ponta, 0)} kWh
                                                    </Td>
                                                    <Td
                                                        alignCenter
                                                        color="#ff6e81"
                                                        backgroundColor="#44444f"
                                                        title={tooltipAlertaPonta}
                                                        style={{
                                                            border: alertaPontaVerde ? "1px solid #26bc58" : alertaPontaVermelho ? "1px solid #c73b55" : null,
                                                        }}
                                                    >
                                                        {adicionarPontosMilhar(percentual_horario_ponta)} %
                                                    </Td>
                                                    <Td backgroundColor="#44444f" alignCenter>
                                                        {alertaForaPontaVerde ? (
                                                            <>
                                                                <i
                                                                    style={{
                                                                        color: "#26bc58",
                                                                        marginRight: 5,
                                                                    }}
                                                                    className="fas fa-thumbs-up"
                                                                ></i>
                                                                <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {alertaForaPontaVermelho ? (
                                                            <>
                                                                <i
                                                                    style={{
                                                                        color: "#c73b55",
                                                                        marginRight: 5,
                                                                    }}
                                                                    className="fas fa-exclamation-circle"
                                                                ></i>
                                                                <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {!alertaForaPontaVerde && !alertaForaPontaVermelho ? <b style={{ color: "#daa710" }}> - </b> : ""}
                                                    </Td>
                                                    <Td alignCenter color="#a3b0f0" backgroundColor="#44444f">
                                                        {adicionarPontosMilhar(consumo_horario_fora_ponta, 0)} kWh
                                                    </Td>
                                                    <Td
                                                        alignCenter
                                                        color="#a3b0f0"
                                                        backgroundColor="#44444f"
                                                        title={tooltipAlertaForaPonta}
                                                        style={{
                                                            border: alertaForaPontaVerde ? "1px solid #26bc58" : alertaForaPontaVermelho ? "1px solid #c73b55" : null,
                                                        }}
                                                    >
                                                        {adicionarPontosMilhar(percentual_horario_fora_ponta)} %
                                                    </Td>
                                                    <Td backgroundColor="#44444f" alignCenter>
                                                        {alertaReservadoVerde ? (
                                                            <>
                                                                <i
                                                                    style={{
                                                                        color: "#26bc58",
                                                                        marginRight: 5,
                                                                    }}
                                                                    className="fas fa-thumbs-up"
                                                                ></i>
                                                                <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {alertaReservadoVermelho ? (
                                                            <>
                                                                <i
                                                                    style={{
                                                                        color: "#c73b55",
                                                                        marginRight: 5,
                                                                    }}
                                                                    className="fas fa-exclamation-circle"
                                                                ></i>
                                                                <i style={{ color: "#daa710" }} className="fas fa-arrow-right"></i>
                                                            </>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {!alertaReservadoVerde && !alertaReservadoVermelho ? <b style={{ color: "#daa710" }}> - </b> : ""}
                                                    </Td>
                                                    <Td alignCenter color="#67f087" backgroundColor="#44444f">
                                                        {adicionarPontosMilhar(consumo_horario_reservado, 0)} kWh
                                                    </Td>
                                                    <Td
                                                        alignCenter
                                                        color="#67f087"
                                                        backgroundColor="#44444f"
                                                        title={tooltipAlertaReservado}
                                                        style={{
                                                            border: alertaReservadoVerde ? "1px solid #26bc58" : alertaReservadoVermelho ? "1px solid #c73b55" : null,
                                                        }}
                                                    >
                                                        {adicionarPontosMilhar(percentual_horario_reservado)} %
                                                    </Td>

                                                    <Td alignCenter color="#ff6e81" backgroundColor="">
                                                        R$ {adicionarPontosMilhar(item.tarifa_horario_ponta)}
                                                    </Td>
                                                    <Td alignCenter color="#a3b0f0" backgroundColor="">
                                                        R$ {adicionarPontosMilhar(item.tarifa_horario_fora_ponta)}
                                                    </Td>
                                                    <Td alignCenter color="#67f087" backgroundColor="">
                                                        R$ {adicionarPontosMilhar(item.tarifa_horario_reservado)}
                                                    </Td>
                                                    <Td alignCenter color="#ff6e81" backgroundColor="">
                                                        R$ {adicionarPontosMilhar(item.tarifa_media_bruta)}
                                                    </Td>
                                                    <Td alignCenter color="#a3b0f0" backgroundColor="">
                                                        R$ {adicionarPontosMilhar(item.tarifa_media_liquida)}
                                                    </Td>
                                                </Tr>
                                            );
                                        })}
                                    </TBody>
                                </Table>
                            </Grid>
                        </Row>
                    </ContentCardBody>
                </ContentCard>
            </Grid>

            <Grid cols="12 12 12 4" style={{ display: "flex", flexDirection: "column" }}>
                <ContentCard style={{ backgroundColor: "#30303d", color: "#fff", padding: 15 }}>
                    <ContentCardBody
                        padding="0"
                        style={{
                            backgroundColor: "#30303d",
                            height: window.innerWidth < 962 ? "fit-content" : 550,
                            overflowX: "hidden",
                            overflowY: "auto",
                        }}
                    >
                        <Row>
                            <div
                                className="callout callout-danger"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100vw",
                                    marginBottom: 10,
                                    color: "#000",
                                }}
                            >
                                <p>
                                    <strong style={{ color: "#bd2130" }}>Horário Ponta:</strong> Representa o custo mais elevado e tem duração de 3h por dia.
                                </p>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td
                                                colSpan="2"
                                                style={{
                                                    backgroundColor: "#fff59d",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "left",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                Orientações para Perfil de Consumo Ideal (valores aproximados dependendo de cada local).
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#c5e1a5",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Irrigações
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#dcedc8",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Próximo a 1%
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#a5d6a7",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Armazéns
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#c8e6c9",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Entre 10% e 20%
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div
                                className="callout callout-success"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100vw",
                                    marginBottom: 10,
                                    color: "#000",
                                }}
                            >
                                <p>
                                    <strong style={{ color: "#1e7e34" }}>Horário Fora Ponta:</strong> Representa um custo mediano e representa os horarios restantes do dia.
                                </p>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td
                                                colSpan="2"
                                                style={{
                                                    backgroundColor: "#fff59d",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "left",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                Orientações para Perfil de Consumo Ideal (valores aproximados dependendo de cada local).
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#c5e1a5",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Irrigações
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#dcedc8",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Próximo a 60%
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#a5d6a7",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Armazéns
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#c8e6c9",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Entre 80% e 90%
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div
                                className="callout callout-purple"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100vw",
                                    marginBottom: 10,
                                    color: "#000",
                                }}
                            >
                                <p>
                                    <strong style={{ color: "#7281bd" }}>Horário Reservado:</strong> Apenas em irrigação, representa o custo mais baixo do dia. Tem duração de 8,5h
                                    por dia (geralmente a noite, podento ter horários diferentes de acordo com contrato com a distribuidora de energia).
                                </p>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td
                                                colSpan="2"
                                                style={{
                                                    backgroundColor: "#fff59d",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "left",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                Orientações para Perfil de Consumo Ideal (valores aproximados dependendo de cada local).
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                style={{
                                                    backgroundColor: "#c5e1a5",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                }}
                                            >
                                                Irrigações
                                            </td>
                                            <td
                                                style={{
                                                    backgroundColor: "#dcedc8",
                                                    paddingLeft: 4,
                                                    paddingRight: 4,
                                                    textAlign: "center",
                                                }}
                                            >
                                                Próximo a 40%
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Row>
                    </ContentCardBody>
                </ContentCard>
            </Grid>
        </Row>
    );
}
